module.exports = function() {
  return new Worker(__webpack_public_path__ + "f02296c97b69bb9075ec.worker.js");
};